import React, { Component, PropTypes } from 'react'
import moment from 'moment-timezone'

import './CalendarModal.scss'
import Modal from 'components/Modal'
import Calendar from './components/Calendar'
import { LOCALE, HORIZON_DAYS } from '@src/globals'

class CalendarModal extends Component {
  constructor (props) {
    super(props)
    this.updateSelectedDate = this.updateSelectedDate.bind(this)
    this.confirmSelectedDate = this.confirmSelectedDate.bind(this)

    this.state = {
      selectedDate: props.minDate
    }
  }

  updateSelectedDate (date) {
    this.setState({
      selectedDate: date
    })
  }

  confirmSelectedDate () {
    const date = this.state.selectedDate
    this.props.onDateSelected(date)
    this.props.onRequestClose()
  }

  render () {
    const {
      isOpen,
      onRequestClose,
      minDate,
      maxDate
    } = this.props

    const {
      selectedDate
    } = this.state

    return (
      <Modal
        isOpen={isOpen}
        contentLabel='CalendarModal'
        onRequestClose={onRequestClose}
        className={'CalendarModal-content'}
        >
        <h1>Elige un día para tu visita</h1>
        <Calendar
          inline
          selected={selectedDate}
          onChange={this.updateSelectedDate}
          minDate={minDate}
          maxDate={maxDate}
          locale={LOCALE}
          />
        <button
          type='button'
          className='btn btn-default btn-block btn-lg CalendarModal-acceptButton'
          onClick={this.confirmSelectedDate} >
          Aceptar
        </button>
      </Modal>
    )
  }
}

CalendarModal.displayName = 'CalendarModal'
CalendarModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDateSelected: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object
}
CalendarModal.defaultProps = {
  minDate: moment(),
  maxDate: moment().add(HORIZON_DAYS, 'days')
}

export default CalendarModal



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/DateSelector/components/CalendarDay/components/CalendarModal/CalendarModal.js